/*
Descrição..........: Service que exibe a caixa de confirmação antes de excluir algum registro
Autor..............: Pablo Ebbers
Data Criação.......: 01/03/2020
Última Atualização.: 17/03/2020

Funções/Métodos:
-----
async showConfirmDelete(name: string, actionRemove: () => void) retorno: Notificação Personalizada
Método para criar e exibir a caixa de diálogo antes de alguma exclusão
-----
*/



import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private alertController: AlertController) { }
  async showConfirmDelete(name: string, actionRemove: () => void) {
    const alert = await this.alertController.create({
      header: 'Deletar?',
      message: `Deseja excluir o item: ${name}?`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Remover',
          handler: () => {
            actionRemove();
          }
        }
      ]
    });

    alert.present();
  }

}
